import { render, staticRenderFns } from "./Dataprivacy.vue?vue&type=template&id=73f44455&scoped=true&"
import script from "./Dataprivacy.vue?vue&type=script&lang=js&"
export * from "./Dataprivacy.vue?vue&type=script&lang=js&"
import style0 from "./Dataprivacy.vue?vue&type=style&index=0&id=73f44455&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../WebApp_Client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f44455",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../WebApp_Client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})
